module.exports = "/deep/ #main-container {\n  background-color: #ffffff !important;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/ippayment-status/ippayment-status.component.css
// module id = ./src/app/shared/components/ippayment-status/ippayment-status.component.css
// module chunks = main